export * from './hero-basic.module';
export * from './hero-basic.component';
